import { useEffect, useState } from 'react';
import { t } from './i18n';

// Sirf tab dikhta hai jab window.Pi maujood NAHI (yani Pi Browser mein nahi).
// Browsing rokta nahi — ek dismissable banner, login/payment se pehle context deta hai.
export default function PiBrowserBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Thora wait — Pi SDK inject hone ka mauka do
    const timer = setTimeout(() => {
      if (typeof window !== 'undefined' && !window.Pi && !sessionStorage.getItem('pi_banner_dismissed')) {
        setShow(true);
      }
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  const dismiss = () => { sessionStorage.setItem('pi_banner_dismissed', '1'); setShow(false); };

  return (
    <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 99998, background: '#fff', borderTop: '3px solid #0F6E56', boxShadow: '0 -4px 20px rgba(0,0,0,0.12)', padding: '14px 16px', fontFamily: 'sans-serif' }}>
      <div style={{ maxWidth: 600, margin: '0 auto', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <img src="/logo192.png" alt="" style={{ width: 34, height: 34, borderRadius: 8, flexShrink: 0 }} onError={(e) => { e.target.style.display = 'none'; }} />
        <div style={{ flex: 1 }}>
          <p style={{ fontSize: 14, fontWeight: 700, margin: '0 0 3px', color: '#2C2C2A' }}>{t('pi_browser_needed_title')}</p>
          <p style={{ fontSize: 12.5, color: '#5F5E5A', margin: '0 0 4px', lineHeight: 1.4 }}>{t('pi_browser_needed_body')}</p>
          <p style={{ fontSize: 11, color: '#0F6E56', margin: 0 }}>{t('pi_browser_how')}</p>
        </div>
        <button onClick={dismiss} style={{ flexShrink: 0, fontSize: 12, fontWeight: 600, padding: '6px 12px', border: '0.5px solid #E3E1D9', borderRadius: 8, background: '#fff', color: '#2C2C2A', cursor: 'pointer' }}>{t('pi_browser_dismiss')}</button>
      </div>
    </div>
  );
}
